import React, { useEffect, useMemo, useState } from 'react';
import curations from '@/assets/images/curations.webp';
import personalise from '@/assets/images/personalise.webp';
import save from '@/assets/images/save.webp';
import searchAI from '@/assets/images/searchAI.webp';
import stores from '@/assets/images/stores.webp';
import virtualTryon from '@/assets/images/virtualTryon.webp';
import styles from './DownloadApp.module.css';
import DownloadAppCarousel from './DownloadAppCarousel';

interface CarouselItem {
  id: string;
  title: string;
  subtitle: string;
  image: string;
}

const carouselItems: CarouselItem[] = [
  {
    id: 'try-on',
    title: 'Download app \n to try this feature',
    subtitle: 'and explore a lot more',
    image: virtualTryon,
  },
  {
    id: 'search',
    title: 'Download app to \n complete the purchase',
    subtitle:
      'Placing and tracking order can only be done \n using the Slayd app',
    image: stores,
  },
  {
    id: 'personalize',
    title: 'Download app \n to save this product',
    subtitle: 'and explore a lot more',
    image: save,
  },
  {
    id: 'curations',
    title: 'Handpicked curations',
    subtitle: '',
    image: curations,
  },
  {
    id: 'brands',
    title: 'Personalise feed based on IG DMs',
    subtitle: '',
    image: personalise,
  },
  {
    id: 'search',
    title: 'Search with AI',
    subtitle: '',
    image: searchAI,
  },
];

interface DownloadAppProps {
  initialSlide: string;
}

const DownloadApp: React.FC<DownloadAppProps> = ({ initialSlide }) => {
  const initialIndex = useMemo(() => {
    const index = carouselItems.findIndex((item) => item.id === initialSlide);
    return index === -1 ? 0 : index;
  }, [initialSlide]);

  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => prevIndex + 1);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const getPlatform = (): string => {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/android/i.test(userAgent)) {
      return 'android';
    }
    if (
      /iPad|iPhone|iPod/.test(userAgent) ||
      (/Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1)
    ) {
      return 'ios';
    }
    if (/Macintosh/.test(userAgent)) {
      return 'mac';
    }
    if (/Windows/.test(userAgent)) {
      return 'windows';
    }
    return 'unknown';
  };

  const handleAppDownload = (): void => {
    const platform = getPlatform();

    switch (platform) {
      case 'android':
        window.open(
          'https://play.google.com/store/apps/details?id=com.slayd.tech',
          '_blank'
        );
        break;
      case 'ios':
      case 'mac':
        window.open(
          'https://apps.apple.com/in/app/slayd-app/id6749233916',
          '_blank'
        );
        break;
      case 'windows':
        window.open(
          'https://play.google.com/store/apps/details?id=com.slayd.tech',
          '_blank'
        );
        break;
      default:
        window.open('https://slayd.tech', '_blank');
        break;
    }
  };

  const { title, subtitle } = useMemo(() => {
    const item = carouselItems.find((item) => item.id === initialSlide);
    return {
      title: item?.title ?? '',
      subtitle: item?.subtitle ?? '',
    };
  }, [initialSlide]);

  const images = carouselItems.map((item) => item.image);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>
      <div className={styles.carouselWrapper}>
        <DownloadAppCarousel
          images={images}
          currentIndex={currentIndex}
          onIndexChange={setCurrentIndex}
        />
      </div>
      <div className={styles.footer}>
        <button className={styles.downloadButton} onClick={handleAppDownload}>
          Download App
        </button>
      </div>
    </div>
  );
};

export default DownloadApp;
